<div class="report-header">
  <div class="psevdo-buttons">
    <div class="time-block regular-time" pTooltip="Regular Hours" tooltipPosition="bottom">
      {{(payPeriod.workDuration / 60) | number:'1.2-2'}}
    </div>
    <div class="time-block regular-time red-time bold-time" pTooltip="Overtime Hours" tooltipPosition="bottom">
      {{(payPeriod.overtimeWorkDuration / 60) | number:'1.2-2'}}
    </div>
    <div class="time-block vac-time" pTooltip="Vacation Hours" tooltipPosition="bottom">
      {{(payPeriod.vacationHoursDuration / 60) | number:'1.2-2'}}
    </div>
    <div class="time-block sick-time" pTooltip="Sick Hours" tooltipPosition="bottom">
      {{(payPeriod.sickHoursDuration / 60) | number:'1.2-2'}}
    </div>

    <div class="time-block regular-time bold-time" pTooltip="Total Hours" tooltipPosition="bottom">
      {{(payPeriod.totalTimeDuration / 60) | number:'1.2-2'}}
    </div>
    <div class="time-block paid-time" pTooltip="Paid Hours" tooltipPosition="bottom">
      {{(payPeriod.paidBreaksDuration / 60) | number:'1.2-2'}}
    </div>
    <div class="time-block unpaid-time" pTooltip="Unpaid Hours" tooltipPosition="bottom">
      {{(payPeriod.unpaidBreaksDuration / 60) | number:'1.2-2'}}
    </div>
  </div>
</div>
